var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PaymentProgressStatusBox',{attrs:{"status-code":_vm.status.code,"status-tooltip":_vm.status.name}})}
var staticRenderFns = []

export { render, staticRenderFns }